import { uniqueId } from "lodash";
import { Tooltip } from "react-tooltip";
import CirclePreview from "./CirclePreview";

export default function CirclePreviewStack({
  dataArray,
  previewOf,
  limit,
}: {
  dataArray: { image_url: string; name: string; is_claimed?: boolean; is_viewed?: boolean }[];
  previewOf: string;
  limit: number;
}) {
  const uniqueID = uniqueId("preview_stack_");
  return (
    <div className="-my-1.5 flex -space-x-5">
      {dataArray
        .reverse()
        .slice(0, limit)
        .map((data, idx) => (
          <CirclePreview
            className="shrink-0 transition-all hover:scale-150"
            // eslint-disable-next-line react/no-array-index-key
            key={uniqueID + data.name + idx}
            imageURL={data.image_url}
            name={data.name}
            previewOf={previewOf}
            isHighlighted={data.is_claimed || data.is_viewed}
          />
        ))}
      {dataArray.length > limit ? (
        <div
          className={`${uniqueID} flex h-12 w-12 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-neutral-300 bg-neutral-300 font-satoshi text-base font-extrabold text-primary hover:border-1 hover:border-white`}
        >
          {`+${dataArray.length - limit}`}
          <Tooltip
            clickable
            style={{ opacity: 1, background: "#1f2732", padding: "18px" }}
            anchorSelect={`.${uniqueID}`}
            variant="dark"
            place="bottom"
          >
            <div className="flex max-w-[16rem] flex-wrap gap-x-1 gap-y-1.5 opacity-100">
              {dataArray.slice(limit).map((data) => (
                <CirclePreview
                  className="h-10 w-10 shrink-0 transition-all hover:scale-150"
                  key={`circle-preview-stack-${data.image_url}-${uniqueID}`}
                  imageURL={data.image_url}
                  name={data.name}
                  previewOf={previewOf}
                  isHighlighted={data.is_claimed || data.is_viewed}
                />
              ))}
            </div>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
}
